/* @flow */
// typecheck: ignore file
import React from 'react';
import { Container } from 'flux/utils';
import Transaction from 'entities/Transaction';
import ActivityStore from 'payments/stores/ActivityStore';
import DepositConfirmation from 'payments/components/DepositConfirmation.jsx';

type Props = {
  activityUUID: string, // eslint-disable-line
  onComplete: Function,
  onCompleteText?: string,
}

type State = {
  transaction?: Transaction,
}

/* DepositConfirmationContainer -
 * Passes the last deposit transactions of the activity
 * to the DepositConfirmation child.
 */
class DepositConfirmationContainer extends React.Component {
  props: Props;
  state: State;

  static getStores() {
    return [
      ActivityStore,
    ];
  }

  static calculateState(_prevState: State, props: Props) {
    const transactions = ActivityStore.getTransactionsForActivityUUID(props.activityUUID).models;
    const withdrawals = transactions.filter(tx => tx.isWithdrawal());
    const transaction = withdrawals[0];

    return {
      transaction,
    };
  }

  render() {
    return (
      <DepositConfirmation
        onComplete={this.props.onComplete}
        onCompleteText={this.props.onCompleteText}
        transaction={this.state.transaction}
      />
    );
  }
}

export default Container.create(DepositConfirmationContainer, { withProps: true });



// WEBPACK FOOTER //
// ./src/payments/containers/DepositConfirmationContainer.jsx